import React from 'react';
import styled from 'styled-components';
import { blockFonts, getCustomFontSize } from 'venn-state';
import { REPORT_LAB_FONT_BODY } from 'venn-ui-kit';
import { useRecoilValue } from 'recoil';
import { useBlockId } from '../../../contexts/BlockIdContext';
import { useIsCorrelationLabelFull } from '../../../logic/useCorrelationLabelDisplay';

const VerticalHeader: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const blockId = useBlockId();
  const tableFont = useRecoilValue(blockFonts.blockTableData(blockId));
  const isFullLabelDisplay = useIsCorrelationLabelFull();
  return (
    <div>
      <VerticalHeaderWrapper fontSize={getCustomFontSize(tableFont)}>
        <VerticalHeaderInner isFullLabelDisplay={isFullLabelDisplay}>{children}</VerticalHeaderInner>
      </VerticalHeaderWrapper>
    </div>
  );
};

export default VerticalHeader;

const VerticalHeaderWrapper = styled.div<{ fontSize: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  ${({ fontSize }) => (fontSize ? `font-size: ${fontSize};` : `font-size: ${REPORT_LAB_FONT_BODY};`)}
`;

const VerticalHeaderInner = styled.div<{ isFullLabelDisplay: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  height: 105px;
  padding: 0px;
  margin: 0px;
  transform: ${({ isFullLabelDisplay }) => (isFullLabelDisplay ? 'none' : 'translateY(-100%)')};
  writing-mode: sideways-lr;

  ${({ isFullLabelDisplay }) =>
    isFullLabelDisplay
      ? `
        white-space: normal;
        word-wrap: break-word;
        -line-clamp: unset;
        line-clamp: unset;
      `
      : `
        -line-clamp: 1;
        line-clamp: 1;
        white-space: nowrap;
      `}
`;
